import { render, staticRenderFns } from "./UpVideoCourse.vue?vue&type=template&id=e5785bfe&scoped=true&"
import script from "./UpVideoCourse.vue?vue&type=script&lang=js&"
export * from "./UpVideoCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5785bfe",
  null
  
)

export default component.exports